import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";
import { OWNER_CONTACT, waLink, mailLink } from "../lib/api";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 border-t border-[#F5F5DC]/10 bg-[#0F0F10]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="font-serif-luxe text-3xl">VacayStay</span>
            <span
              className="font-serif-luxe text-3xl italic"
              style={{ color: "var(--vs-gold)" }}
            >
              Rentals
            </span>
          </div>
          <p className="mt-6 text-[#A3A3A3] max-w-md leading-relaxed">
            A private collection of vacation homes, hand-picked and personally
            hosted. No middleman. No hidden fees. Just a quiet key handed over
            in a beautiful place.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li>
              <Link
                to="/properties"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-link-properties"
              >
                Properties
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-link-about"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-link-contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-5">Get in touch</p>
          <div className="space-y-3 text-sm">
            <a
              href={mailLink("Inquiry via vacaystayrentals.com")}
              data-testid="footer-email"
              className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"
            >
              <Mail size={14} /> {OWNER_CONTACT.email}
            </a>
            <a
              href={`tel:+${OWNER_CONTACT.whatsapp}`}
              data-testid="footer-phone"
              className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"
            >
              <Phone size={14} /> {OWNER_CONTACT.phone}
            </a>
            <a
              href={waLink("Hi! I found you on vacaystayrentals.com and I'd love to book a stay.")}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"
            >
              <MessageCircle size={14} /> WhatsApp
            </a>
            <a
              href={`https://instagram.com/${OWNER_CONTACT.instagram}`}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"
            >
              <Instagram size={14} /> @{OWNER_CONTACT.instagram}
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#F5F5DC]/10 py-6 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[#737373]">
        <p>© {new Date().getFullYear()} VacayStay Rentals. All rights reserved.</p>
        <Link
          to="/admin/login"
          className="hover:text-[#D4AF37] transition-colors"
          data-testid="footer-admin-link"
        >
          Host login
        </Link>
      </div>
    </footer>
  );
}
